import * as React from 'react';
import PropTypes from 'prop-types';

const SearchIcon = props => (
  <svg
    className={props.className}
    style={{
      width: props.size,
      height: props.size,
    }}
    viewBox={`0 0 ${props.size - 5} ${props.size - 5}`}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={props.color}
      strokeLinecap="square"
      transform="translate(5 5)"
    >
      <path d="M21.5 21.5l-3-3" />
      <circle cx="9.5" cy="9.5" r="9" />
      <path d="M4.6 8.5C5 6.5 6.5 5 8.5 4.6" />
    </g>
  </svg>
);

SearchIcon.defaultProps = {
  color: '#000',
  className: null,
  size: 35,
};

SearchIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default SearchIcon;
